/**
 * @generated SignedSource<<c14d4a90eaa452dec5c10faad378b23e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_viewer$data = {
  readonly buyerUrgencyInfo?: {
    readonly itemUrgency: {
      readonly hasUrgencyInfo: boolean | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedUrgencyLazy_buyerUrgencyInfo">;
  } | null;
  readonly isWordpressArticlesEnabled: boolean | null;
  readonly pdpOptinPromptFF: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerChatLoader_viewer" | "PdpRespDetailTabs_viewer" | "PdpRespIconBubblesWrapper_viewer" | "PdpRespPersonalizedItemsCarouselLazy_viewer" | "PdpRespSellerItemsCarousel_viewer" | "PdpRespSharedHeroCarousel_viewer" | "PdpRespSidebarBlurbs_viewer" | "PdpRespSidebarButtons_viewer" | "PdpRespSimilarAuctionItemsLazy_viewer" | "PdpRespSimilarItemsCarousel_viewer" | "PdpRespYMALItemsCarousel_viewer" | "PdpSharedAuctionInfo_viewer" | "PdpSharedPromoCode_viewer" | "PdpSharedRestrictedMaterialsLoader_viewer" | "SharedRespLinksBlock_viewer">;
  readonly " $fragmentType": "PdpRespContainer_viewer";
};
export type PdpRespContainer_viewer$key = {
  readonly " $data"?: PdpRespContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchAuction"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_viewer",
  "selections": [
    {
      "alias": "isWordpressArticlesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "WP_EDITORIAL"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
    },
    {
      "alias": "pdpOptinPromptFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "pdpOptinPrompt"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"pdpOptinPrompt\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_viewer"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespYMALItemsCarousel_viewer"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "priceBookName",
              "variableName": "priceBookName"
            }
          ],
          "kind": "FragmentSpread",
          "name": "PdpRespSellerItemsCarousel_viewer"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "fetchBuyerUrgencyInfo",
              "variableName": "isClient"
            }
          ],
          "kind": "FragmentSpread",
          "name": "PdpRespSharedHeroCarousel_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespIconBubblesWrapper_viewer"
        }
      ]
    },
    {
      "condition": "fetchAuction",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPersonalizedItemsCarouselLazy_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsCarousel_viewer"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDealerChatLoader_viewer"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "BuyerUrgencyInfo",
          "kind": "LinkedField",
          "name": "buyerUrgencyInfo",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedUrgencyLazy_buyerUrgencyInfo"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemUrgencyInfoType",
              "kind": "LinkedField",
              "name": "itemUrgency",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasUrgencyInfo",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRestrictedMaterialsLoader_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_viewer"
    },
    {
      "condition": "fetchAuction",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSimilarAuctionItemsLazy_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedAuctionInfo_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetailTabs_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f1901ef1ea692073131fdfe6f93f516b";

export default node;
